import React from "react";
import miiLogo from '../../assets/images/mmiilogo.png'
import ResponsiveCarousel from "./ResponsiveCarousel";
import carouselImage1 from '../../assets/images/carousel/mmMarketingAd1.png';
import carouselImage2 from '../../assets/images/carousel/mmMarketingAd2.png';
import carouselImage3 from '../../assets/images/carousel/mmMarketingAd3.png';

export const Loader = () => {

  const carouselImages = [
    {
      src: carouselImage1,
      alt: 'Image 1',
    },
    {
      src: carouselImage2,
      alt: 'Image 2',
    },
    {
      src: carouselImage3,
      alt: 'Image 3',
    },
  ]
  
  return (
    <div className="fixed z-10 inset-0 overflow-y-auto">
      <div className="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
        <div className="fixed inset-0 transition-opacity">
          <div className="absolute inset-0 bg-gray-500 opacity-75"></div>
        </div>
        <span className="hidden sm:inline-block sm:align-middle sm:h-screen"></span>
        <div className="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full">
          <div className="bg-white-700 px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
            <div className="sm:flex sm:items-start justify-center">
              <div className="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
                <ResponsiveCarousel images={carouselImages} autoPlay={true} infiniteLoop={false} showStatus={false} showThumbs={false} showIndicators={false} showArrows={false} interval={3000} />
              </div>
            </div>
          </div>
          <div className="bg-white-700 px-4 py-3 sm:px-6 sm:flex sm:flex-col">
            <div className="flex flex-row  w-full justify-center p-5">
              <img className="object-contain h-[4rem]"  src={miiLogo} alt="Job Description"/>
            </div>
            <div className="flex flex-row  w-full justify-center">
              <span className="font-bold text-[1.2rem] p-5 text-center">Generating your Job Description... This may take 5 to 10 seconds. Please be patient.</span>
            </div>
            <div className="flex flex-row w-full justify-center">
              <div className="flex h-full w-full z-[9999] top-0 left-0 justify-center align-center">
                <div className="border-[4px] border-gray-700 border-t-blue-600 animate-spin h-[2rem] w-[2rem] rounded-[50%]" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
